import router from "@/router";
import store from "@/store";
import getPageTitle from "@/utils/get-page-title";
import { getStorage } from "@/utils/storage";

const subjectVO = getStorage("subjectVO");
let firstInPage = true; // 判断是否为刷新页面进入或者第一次进入

// 说明：此前这里对 STORY#3197 专业版购买相关页面（/proPlan/*）做过「未登录跳登录页」拦截，
// 目的是避免渲染出企业信息为空的空壳页面。但该拦截会误伤 H5 场景
// （权益详情页经 APICloud openFrame 打开、需免登录访问），且未登录时接口本就会失败、
// 页面只是无数据而不会泄露任何信息，故已按要求移除该拦截。
//
// ⚠️ 约定：**权益详情页（/proPlan/rightsDetail）在 H5 下必须无需登录即可访问**
//   （可对外分享 / App 内 openFrame 打开）。H5 的识别见 utils/index.js 的 isMobile()：
//   URL `?platform=h5` → App UA（vue_apicloud / yonyoucloud_app）→ api.systemType → UA/宽度。
//   若将来要恢复登录引导，务必保留该页在 H5 下的免登录，或改用页面内提示而非强制 redirect。

router.beforeEach(async (to, from, next) => {
  const hasToken = !!getStorage("ACCESSTOKEN");

  next();
  // subjectVO 可能缺失（未登录 / 缓存被清），兜底避免守卫抛错导致后续权限不加载
  document.title = getPageTitle(subjectVO && subjectVO.productName);

  if (hasToken) {
    if (firstInPage) {
      store.commit("setFidAndCid");
      await store.dispatch("permission/getPermissions");
      firstInPage = false;
    }
  }
});

router.afterEach(() => {});
